// Exports
export default {
	"CoverLayer": "CoverLayer_B3rQ9",
	"CoverLayer_absolute": "CoverLayer_absolute_PtYZ5"
};
